import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Header } from "../../components/header";
import { DiagnosticoInicialService } from "../../services/diagnostico-inicial.service";
import { analyticsService } from "../../services/firebase-service";

export const DiagnosticoInicial = () => {
  const navigate = useNavigate();
  const [btnText, setBtnText] = useState("Quero o diagnóstico da minha empresa");
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    analyticsService.event("page-diagnostico-inicial");
  }, []);

  const register = async (formData: FormData) => {
    const object: { [key: string]: string } = {};
    formData.forEach((value, key) => (object[key] = (value ?? "") as string));
    console.log(object);

    const service = new DiagnosticoInicialService();
    await service
      .register(object)
      .then(value => {
        console.log(value);
        navigate({ pathname: "/diagnostico-inicial/em-breve" });
      })
      .catch(error => console.log(error))
      .finally(() => {
        setEnabled(true);
        setBtnText("Quero o diagnóstico da minha empresa");
      });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setEnabled(false);
    setBtnText("Salvando seus dados. Aguarde...");
    const formData = new FormData(e.currentTarget);
    await register(formData);
  };

  return (
    <main className="container">
      <Header />
      <div className="header header-diagnostico-inicial">
        <p className="mt-4" style={{ maxWidth: 600 }}>
          📝 Questionário de diagnóstico para Microempresas e Prestadores de Serviço
        </p>
      </div>
      <div className="mt-3 content">
        <div className="col-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 align-items-center justify-content-center">
          <div className="box">
            <form onSubmit={handleSubmit} method="post">
              {/* Seção 1 - Identificação da empresa */}
              <fieldset className="mb-4">
                <legend className="h4">Seção 1 - Identificação da empresa</legend>
                <div className="mb-3">
                  <label className="form-label" htmlFor="nome_empresa">
                    Nome da sua Empresa
                    <span className="required">*</span>
                  </label>
                  <input type="text" className="form-control" id="nome_empresa" name="nome_empresa" placeholder="Insira o nome da sua empresa" required />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="nome_completo">
                    Seu Nome Completo
                    <span className="required">*</span>
                  </label>
                  <input type="text" className="form-control" id="nome_completo" name="nome_completo" placeholder="Insira seu nome e sobrenome" required />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="email_profissional">
                    E-mail profissional
                    <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email_profissional"
                    name="email_profissional"
                    placeholder="Insira seu melhor e-mail profissional"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="telefone">
                    DDD + Telefone
                    <span className="required">*</span>
                  </label>
                  <input type="tel" className="form-control" id="telefone" name="telefone" placeholder="Insira seu WhatsApp (DDD + Telefone)" required />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Como conheceu o questionário de diagnóstico?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="como_conheceu" id="conheceu1" value="indicacao" required />
                    <label className="form-check-label" htmlFor="conheceu1">
                      Indicação
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="como_conheceu" id="conheceu2" value="redes_sociais" required />
                    <label className="form-check-label" htmlFor="conheceu2">
                      Redes sociais
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="como_conheceu" id="conheceu3" value="evento" required />
                    <label className="form-check-label" htmlFor="conheceu3">
                      Evento
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="como_conheceu" id="conheceu4" value="busca_google" required />
                    <label className="form-check-label" htmlFor="conheceu4">
                      Busca no Google
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="como_conheceu" id="conheceu5" value="outro" required />
                    <label className="form-check-label" htmlFor="conheceu5">
                      Outro
                    </label>
                  </div>
                  <input type="text" className="form-control mt-2" name="como_conheceu_outro" id="como_conheceu_outro" placeholder="Se outro, especifique" />
                </div>
              </fieldset>

              {/*Seção 2 - Gestão do Negócio*/}
              <fieldset className="mb-4">
                <legend className="h4">Seção 2 - Gestão do Negócio</legend>

                <div className="mb-3">
                  <label className="form-label">
                    Você registra as finanças (entradas, saídas, compras e vendas)?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="registro_financas" id="registro1" value="nao" required />
                    <label className="form-check-label" htmlFor="registro1">
                      Não registro nada
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="registro_financas" id="registro2" value="caderno" required />
                    <label className="form-check-label" htmlFor="registro2">
                      Uso caderno/planilha simples
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="registro_financas" id="registro3" value="sistema" required />
                    <label className="form-check-label" htmlFor="registro3">
                      Uso sistema/planilha organizada regularmente
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Você separa as finanças pessoais das finanças da empresa?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="separa_financas" id="separa1" value="misturado" required />
                    <label className="form-check-label" htmlFor="separa1">
                      Não, tudo misturado
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="separa_financas" id="separa2" value="tento" required />
                    <label className="form-check-label" htmlFor="separa2">
                      Tento separar, mas às vezes confundo
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="separa_financas" id="separa3" value="separado" required />
                    <label className="form-check-label" htmlFor="separa3">
                      Sim, totalmente separado
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Como faz suas retiradas do negócio?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="retiradas" id="retirada1" value="sem_controle" required />
                    <label className="form-check-label" htmlFor="retirada1">
                      Retiro quando preciso, sem controle
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="retiradas" id="retirada2" value="valor_medio" required />
                    <label className="form-check-label" htmlFor="retirada2">
                      Tenho um valor médio em mente, mas não fixo
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="retiradas" id="retirada3" value="pro_labore" required />
                    <label className="form-check-label" htmlFor="retirada3">
                      Tenho um pró-labore definido e controlado
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Qual é a situação da sua empresa?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="situacao_empresa" id="situacao1" value="informal" required />
                    <label className="form-check-label" htmlFor="situacao1">
                      Informal (não tenho CNPJ)
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="situacao_empresa" id="situacao2" value="mei_me" required />
                    <label className="form-check-label" htmlFor="situacao2">
                      Formalizada como MEI/ME
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="situacao_empresa" id="situacao3" value="estrutura_maior" required />
                    <label className="form-check-label" htmlFor="situacao3">
                      Formalizada e com estrutura maior (funcionários, contratos, etc.)
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Quantos funcionários (ou parceiros fixos) você possui?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="funcionarios" id="func1" value="nenhum" required />
                    <label className="form-check-label" htmlFor="func1">
                      Nenhum, trabalho sozinho
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="funcionarios" id="func2" value="1_3" required />
                    <label className="form-check-label" htmlFor="func2">
                      1 a 3 pessoas
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="funcionarios" id="func3" value="4_mais" required />
                    <label className="form-check-label" htmlFor="func3">
                      4 ou mais pessoas
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Sua empresa possui algum tipo de consultoria ou apoio externo (contábil, gestão, marketing etc)?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="consultoria" id="consultoria1" value="nao" required />
                    <label className="form-check-label" htmlFor="consultoria1">
                      Não
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="consultoria" id="consultoria2" value="as_vezes" required />
                    <label className="form-check-label" htmlFor="consultoria2">
                      Sim, de vez em quando
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="consultoria" id="consultoria3" value="regularmente" required />
                    <label className="form-check-label" htmlFor="consultoria3">
                      Sim, regularmente
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Você já participou de capacitações, cursos ou eventos de empreendedorismo?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="capacitacao" id="capacitacao1" value="nao" required />
                    <label className="form-check-label" htmlFor="capacitacao1">
                      Não
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="capacitacao" id="capacitacao2" value="sim_um" required />
                    <label className="form-check-label" htmlFor="capacitacao2">
                      Sim, uma vez
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="capacitacao" id="capacitacao3" value="sim_varias" required />
                    <label className="form-check-label" htmlFor="capacitacao3">
                      Sim, várias vezes
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Existe planejamento estratégico/documentado para o seu negócio?<span className="required">*</span>
                  </label>

                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="planejamento" id="planejamento1" value="nao" required />
                    <label className="form-check-label" htmlFor="planejamento1">
                      Não tenho
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="planejamento" id="planejamento2" value="nao_documentado" required />
                    <label className="form-check-label" htmlFor="planejamento2">
                      Tenho ideias, mas não documentadas
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="planejamento" id="planejamento3" value="estruturado" required />
                    <label className="form-check-label" htmlFor="planejamento3">
                      Tenho planejamento estruturado/documentado
                    </label>
                  </div>
                </div>
              </fieldset>

              {/* Seção 3 - Posicionamento Digital */}
              <fieldset className="mb-4">
                <legend className="h4">Seção 3 - Posicionamento Digital</legend>

                <div className="mb-3">
                  <label className="form-label">
                    Sua empresa está em quais canais digitais?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="canais_digitais" id="canais1" value="sem_presenca" required />
                    <label className="form-check-label" htmlFor="canais1">
                      Não tenho presença digital
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="canais_digitais" id="canais2" value="redes_sociais" required />
                    <label className="form-check-label" htmlFor="canais2">
                      Tenho perfis em algumas redes sociais
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="canais_digitais" id="canais3" value="redes_sociais_site" required />
                    <label className="form-check-label" htmlFor="canais3">
                      Tenho redes sociais ativas + site ou Google Meu Negócio
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Sobre sua produção de conteúdo:<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="producao_conteudo" id="conteudo1" value="nao_publica" required />
                    <label className="form-check-label" htmlFor="conteudo1">
                      Não publico nada
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="producao_conteudo" id="conteudo2" value="sem_padrao" required />
                    <label className="form-check-label" htmlFor="conteudo2">
                      Publico de vez em quando, sem padrão
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="producao_conteudo" id="conteudo3" value="frequente_identidade" required />
                    <label className="form-check-label" htmlFor="conteudo3">
                      Tenho frequência e identidade visual definida
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Você já investe em anúncios pagos (Meta Ads, Google Ads, etc.)?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="anuncios_pagos" id="anuncio1" value="nunca" required />
                    <label className="form-check-label" htmlFor="anuncio1">
                      Nunca
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="anuncios_pagos" id="anuncio2" value="teste_uma_vez" required />
                    <label className="form-check-label" htmlFor="anuncio2">
                      Já testei uma vez
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="anuncios_pagos" id="anuncio3" value="frequente" required />
                    <label className="form-check-label" htmlFor="anuncio3">
                      Invisto com frequência
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Como organiza o contato com clientes?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="relacionamento_clientes" id="relacionamento1" value="whatsapp_pessoal" required />
                    <label className="form-check-label" htmlFor="relacionamento1">
                      Só pelo WhatsApp pessoal
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="relacionamento_clientes" id="relacionamento2" value="whatsapp_business" required />
                    <label className="form-check-label" htmlFor="relacionamento2">
                      Uso WhatsApp Business/planilha
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="relacionamento_clientes" id="relacionamento3" value="crm" required />
                    <label className="form-check-label" htmlFor="relacionamento3">
                      Tenho CRM ou controle estruturado de contatos
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Como avalia sua presença digital para atrair clientes?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="avaliacao_digital" id="avalia1" value="quase_nenhum" required />
                    <label className="form-check-label" htmlFor="avalia1">
                      Quase não recebo clientes por canais digitais
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="avaliacao_digital" id="avalia2" value="alguns" required />
                    <label className="form-check-label" htmlFor="avalia2">
                      Recebo alguns, mas a maioria ainda vem offline
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="avaliacao_digital" id="avalia3" value="maioria_digital" required />
                    <label className="form-check-label" htmlFor="avalia3">
                      A maior parte dos clientes vem do digital
                    </label>
                  </div>
                </div>
              </fieldset>

              {/* Seção 4 - Canais e Marketing Offline */}
              <fieldset className="mb-4">
                <legend className="h4">Seção 4 - Canais e Marketing Offline</legend>

                <div className="mb-3">
                  <label className="form-label">
                    Quais são os principais canais de venda do seu negócio?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" name="canais_venda[]" id="venda1" value="presencial" />
                    <label className="form-check-label" htmlFor="venda1">
                      Presencial/Loja física
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" name="canais_venda[]" id="venda2" value="ecommerce" />
                    <label className="form-check-label" htmlFor="venda2">
                      E-commerce próprio
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" name="canais_venda[]" id="venda3" value="marketplace" />
                    <label className="form-check-label" htmlFor="venda3">
                      Marketplaces
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" name="canais_venda[]" id="venda4" value="redes_sociais" />
                    <label className="form-check-label" htmlFor="venda4">
                      Redes sociais
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" name="canais_venda[]" id="venda5" value="outros" />
                    <label className="form-check-label" htmlFor="venda5">
                      Outros
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Você divulga seu negócio fora da internet?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="marketing_offline" id="offline1" value="nao" required />
                    <label className="form-check-label" htmlFor="offline1">
                      Não
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="marketing_offline" id="offline2" value="pontual" required />
                    <label className="form-check-label" htmlFor="offline2">
                      Sim, mas de forma pontual (cartão, panfleto, boca a boca)
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="marketing_offline" id="offline3" value="frequente" required />
                    <label className="form-check-label" htmlFor="offline3">
                      Sim, invisto com frequência em ações locais
                    </label>
                  </div>
                </div>
              </fieldset>

              {/* Seção 5 - Perfil */}
              <fieldset className="mb-4">
                <legend className="h4">Seção 5 - Perfil</legend>

                <div className="mb-3">
                  <label className="form-label">
                    Ramo de atividade principal:<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="ramo_atividade" id="ramo1" value="comercio" required />
                    <label className="form-check-label" htmlFor="ramo1">
                      Comércio
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="ramo_atividade" id="ramo2" value="servicos" required />
                    <label className="form-check-label" htmlFor="ramo2">
                      Serviços
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="ramo_atividade" id="ramo3" value="alimentacao" required />
                    <label className="form-check-label" htmlFor="ramo3">
                      Alimentação
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="ramo_atividade" id="ramo4" value="beleza" required />
                    <label className="form-check-label" htmlFor="ramo4">
                      Beleza e estética
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="ramo_atividade" id="ramo5" value="outro" required />
                    <label className="form-check-label" htmlFor="ramo5">
                      Outro
                    </label>
                  </div>
                  <input type="text" className="form-control mt-2" name="ramo_outro" id="ramo_outro" placeholder="Se outro, especifique" />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Tempo de empresa:<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="tempo_empresa" id="tempo1" value="menos_1" required />
                    <label className="form-check-label" htmlFor="tempo1">
                      Menos de 1 ano
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="tempo_empresa" id="tempo2" value="1_3" required />
                    <label className="form-check-label" htmlFor="tempo2">
                      Entre 1 e 3 anos
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="tempo_empresa" id="tempo3" value="3_5" required />
                    <label className="form-check-label" htmlFor="tempo3">
                      Entre 3 e 5 anos
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="tempo_empresa" id="tempo4" value="mais_5" required />
                    <label className="form-check-label" htmlFor="tempo4">
                      Mais de 5 anos
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Faturamento médio mensal (faixa):<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="faturamento" id="faturamento1" value="ate_5mil" required />
                    <label className="form-check-label" htmlFor="faturamento1">
                      Até R$ 5 mil
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="faturamento" id="faturamento2" value="5a20mil" required />
                    <label className="form-check-label" htmlFor="faturamento2">
                      De R$ 5 mil a R$ 10 mil
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="faturamento" id="faturamento3" value="5a20mil" required />
                    <label className="form-check-label" htmlFor="faturamento3">
                      De R$ 10 mil a R$ 25 mil
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="faturamento" id="faturamento4" value="5a20mil" required />
                    <label className="form-check-label" htmlFor="faturamento4">
                      De R$ 25 mil a R$ 50 mil
                    </label>
                  </div>

                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="faturamento" id="faturamento5" value="mais_20mil" required />
                    <label className="form-check-label" htmlFor="faturamento5">
                      Acima deR$ 50 mil
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="faturamento" id="faturamento6" value="prefiro_nao_dizer" required />
                    <label className="form-check-label" htmlFor="faturamento6">
                      Prefiro não dizer
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Qual é hoje seu maior desafio?<span className="required">*</span>
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="maior_desafio" id="desafio1" value="atrair_clientes" required />
                    <label className="form-check-label" htmlFor="desafio1">
                      Atrair clientes
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="maior_desafio" id="desafio2" value="controlar_financas" required />
                    <label className="form-check-label" htmlFor="desafio2">
                      Controlar finanças
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="maior_desafio" id="desafio3" value="organizacao_interna" required />
                    <label className="form-check-label" htmlFor="desafio3">
                      Melhorar organização interna
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="maior_desafio" id="desafio4" value="crescer_escalar" required />
                    <label className="form-check-label" htmlFor="desafio4">
                      Crescer e escalar
                    </label>
                  </div>
                </div>
              </fieldset>

              <div className="mb-3">
                <label className="form-label" htmlFor="outros_pontos">
                  Gostaria de compartilhar algum outro desafio, necessidade ou observação?
                </label>
                <textarea className="form-control" id="outros_pontos" name="outros_pontos" rows={3} placeholder="Descreva aqui..." />
              </div>

              <div>
                <p>🔒 Seus dados serão usados apenas para comunicação relacionada a comunidade de empreendedores e diagnóstico da sua empresa.</p>
              </div>
              <div>
                <p>
                  👉 Ao continuar você aceita nossa{" "}
                  <Link target="_blank" to="/politica-de-privacidade" className="link-secondary">
                    <strong>política de privacidade</strong>
                  </Link>
                  .
                </p>
              </div>
              <div className="d-grid mt-4 mb-3">
                <button type="submit" className="btn btn-primary p-2" disabled={!enabled}>
                  {btnText}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};
